import React from 'react';
import cn from 'classnames';
import {
  Section as ElementSection,
  FormSection,
  ListInfo,
} from 'views/pages/ClientDetail/components/Elements';
import { useIsInternalUser, useIsOwnerRecord } from 'helper/hooks';
import { getMomentDate } from 'utils/date';
import { SSN_FIELD } from 'helper/const';
import SecurityField from 'components/SecurityField';
import InputItem from 'views/pages/ClientDetail/components/InputItem';
import InputItemEmpty from 'views/pages/ClientDetail/components/InputItem/Empty';
import { PROFILE_OBJ_KEYS } from '../../constants';
import classes from './Section.module.scss';

const Profile = ({
  className,
  isEdit,
  form,
  data,
  disabled,
  clientId,
  isNew,
}) => {
  const { isInternalUser, isExternalOwner } = useIsInternalUser();
  const isOwnerRecord = useIsOwnerRecord(data?.id);

  return (
    <div className={cn(classes.profileSection, className)}>
      <ElementSection className={classes.elSection}>
        {isEdit ? (
          <FormSection>
            {/* Use it to save delete_attachments for attachment removing */}
            <InputItem name={'delete_attachments'} label="" form={form} hide />
            <InputItem
              name={'first_name'}
              label="First Name"
              form={form}
              required
              addressGroupField
              disabled={disabled}
            />
            <InputItem
              name={'middle_name'}
              label="Middle Name"
              form={form}
              addressGroupField
              disabled={disabled}
            />
            <InputItem
              name={'last_name'}
              label="Last Name"
              form={form}
              required
              addressGroupField
              disabled={disabled}
            />
            <InputItem
              name={'suffix'}
              label="Suffix"
              form={form}
              addressGroupField
              disabled={disabled}
            />
            <InputItem
              name={'phone'}
              label="Phone"
              form={form}
              type="phone"
              required
              disabled={disabled}
            />
            <InputItem
              name={'email'}
              label="Email"
              form={form}
              disabled={disabled}
            />
            {isInternalUser ? (
              <SecurityField
                fieldObj={{
                  label: 'DOB - Date of Birth',
                  value: '********',
                  type_id: data?.id,
                  type: 'driver',
                  company_id: clientId,
                  key: 'dob',
                  alwaysDisplayView: isNew,
                }}
                viewRender={isShow => {
                  return (
                    <InputItem
                      name={'dob'}
                      label="DOB - Date of Birth"
                      type="date"
                      form={form}
                      disabled={disabled}
                      hide={!isShow}
                    />
                  );
                }}
                pinSuccessCb={val => {
                  form.setFieldsValue({
                    dob: val ? getMomentDate(val, false, true) : '',
                  });
                }}
              />
            ) : isExternalOwner || isOwnerRecord ? (
              <InputItem
                name={'dob'}
                label="DOB - Date of Birth"
                type="date"
                form={form}
                disabled={disabled}
              />
            ) : (
              <InputItemEmpty />
            )}
            {isInternalUser ? (
              <SecurityField
                fieldObj={{
                  label: 'SSN - Social Security Number',
                  value: '********',
                  type_id: data?.id,
                  type: 'driver',
                  company_id: clientId,
                  key: 'ssn',
                  alwaysDisplayView: isNew,
                }}
                viewRender={isShow => {
                  return (
                    <InputItem
                      name={'ssn'}
                      label="SSN - Social Security Number"
                      type="number"
                      mask={SSN_FIELD.MASK}
                      placeholder={SSN_FIELD.PLACEHOLDER}
                      form={form}
                      disabled={disabled}
                      hide={!isShow}
                    />
                  );
                }}
                pinSuccessCb={val => {
                  form.setFieldsValue({
                    ssn: val,
                  });
                }}
              />
            ) : isExternalOwner || isOwnerRecord ? (
              <InputItem
                name={'ssn'}
                label="SSN - Social Security Number"
                type="number"
                mask={SSN_FIELD.MASK}
                placeholder={SSN_FIELD.PLACEHOLDER}
                form={form}
                disabled={disabled}
              />
            ) : (
              <InputItemEmpty />
            )}
          </FormSection>
        ) : (
          <ListInfo
            objKeys={PROFILE_OBJ_KEYS}
            data={data}
            sType="driver"
            sCompanyId={clientId}
            needSecure
          />
        )}
      </ElementSection>
    </div>
  );
};

export default Profile;
